import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment-timezone'
import styled from 'styled-components'
import { Calendar as BigCalendar, momentLocalizer } from 'react-big-calendar'
import {cloneDeep} from 'lodash'
import { RRule } from 'rrule'
import { gt as version_greater_than, lt as version_less_than } from 'semver'

import { newSchedule, focusSchedule, selectAllSchedules, fetchStation} from '../../../store/rules/ruleSchedulesSlice';
import { getSelectedNodes, toggleUsePowerSchedules } from '../../../store/positions/menuNodesSlice'
import { toggleEnabled as toggleSettingsEnabled, getSettings } from '../../../store/rules/settingsSlice';
import { EditPanel } from './EditPanel'
import { ScheduleStyle } from '../../../store/rules/types'
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { Toggle } from '../../common/fields/devices/Toggle';
import { checkOverlapping } from '../../../lib/overlap';
import { colour_lookup } from '../../common/Colours';

let MyCustomHeader = ({ label }) => {
  
  return (
      <StyledHeader>
        {label.split(' ')[1]}
      </StyledHeader>
  )
}

const StyledHeader = styled.div`
  font-weight: 300;
  padding: 10px 0;
`;

const StyledBigCalendar = styled(BigCalendar)`
  padding: 10px 5% 20px 5%;
  overflow: hidden;
`;

let MyCustomToolbar = ({ onView, label, views }) => {
  
  return (
      <div></div>
  )
}

let MySchedule = (props) => {  
  return props.children
}

const StyledContainer = styled.div`
  display: flex;
  height: 100%;
  max-width: 100%;
`;

const Middle = styled.div`
  height: 90%;
  width: 75%;
`;

const Right = styled.div`
  border-left: 1px solid #AAA;
  height: 100%;
  width: 25%;
`;

const StyledDisabledMessage = styled.div`
  width: 100%;
  height: 100%;
  color: #333;
  text-align: center;
  
  div {
    position: fixed;
    top: 50%;
    left: 50%;
    -ms-transform: translateY(-50%) translateX(-50%);
    transform: translateY(-50%) translateX(-50%);
  }
  
  span {
    display: block;
    padding: 10px 0;
  }
`;

const DisabledMessage = () => {
  return (
    <StyledDisabledMessage>
      <div>
        <span>Power Management is currently disabled for this Position</span>
        <span>The system will be permanently ON</span>
        <span>Enable using the toggle in the top right corner</span>
      </div>
    </StyledDisabledMessage>
  )
}

const StyledFirmwareMessage = styled.div`
  width: 100%;
  height: 100%;
  color: #333;
  text-align: center;
  
  div {
    position: fixed;
    top: 50%;
    left: 50%;
    -ms-transform: translateY(-50%) translateX(-50%);
    transform: translateY(-50%) translateX(-50%);
  }
  
  span {
    display: block;
    padding: 10px 0;
  }
`;

const FirmwareMessage = () => {
  return (
    <StyledFirmwareMessage>
      <div>
        <span>Device firmware must be upgraded to use this feature</span>
      </div>
    </StyledFirmwareMessage>
  )
}

const StyledSelectMessage = styled.div`
  width: 100%;
  height: 100%;
  color: #333;
  text-align: center;
  
  div {
    position: fixed;
    top: 50%;
    left: 50%;
    -ms-transform: translateY(-50%) translateX(-50%);
    transform: translateY(-50%) translateX(-50%);
  }
  
  span {
    display: block;
    padding: 10px 0;
  }
`;

const SelectMessage = () => {
  return (
    <StyledSelectMessage>
      <div>
        <span>Select a Position in the left menu to start</span>
      </div>
    </StyledSelectMessage>
  )
}

const StyledPowerSchedulesToggle = styled.div`
  width: 100%;
  margin: 0 auto;
  padding: 25px 50px 15px 0 ;
  color: #333;
  display: flex;
  justify-content: flex-end;
  // border-bottom: 1px solid #AAA;
`;

const PowerSchedulesToggle = ({ children }: { children?: React.ReactNode }) => {
  return (
    <StyledPowerSchedulesToggle>
     {children}
    </StyledPowerSchedulesToggle>
  )
}

const PowerSchedulesToggleLabel = ({ children }: { children?: React.ReactNode }) => {
  return (
    <StyledPowerSchedulesToggle>
     {children}
    </StyledPowerSchedulesToggle>
  )
}

const ToggleLabel = styled.div`
  padding: 4px 10px;
  font-size: 16px;
  color: #333;
`;

export function Alarms({ path: string }) {
  
  const dispatch = useDispatch();
  const selectedNodes = useSelector(getSelectedNodes);
  // useEffect(() => { dispatch(fetchStation(5)) }, [])
  
  
  
  const calendar_items = useSelector(selectAllSchedules);
  const focusedSchedule = calendar_items.filter(schedule => schedule.focus)[0] || null;
  const globalSettings = useSelector(getSettings);
  
  
  let calendar_items_recurring = [];
   
  calendar_items.forEach((item) => {
    const rule = new RRule({
      freq: RRule.WEEKLY,
      interval: item.interval,
      byweekday: item.byweekday,
      dtstart: new Date(moment.tz(item.dtstart, 'UTC').valueOf()),
      until: item.until
    });
    
    const weekstart = moment().startOf('isoWeek').subtract(1, 'week');
    const weekend = moment().endOf('isoWeek');
    
    let occurences = rule.between(new Date(weekstart.valueOf()), new Date(weekend.valueOf()));

    occurences.forEach((dtstart, index) => {
      let cloned_item :any = cloneDeep(item);
      cloned_item.dtstart = new Date(moment(moment(dtstart).utc().format('YYYY-MM-DD HH:mm:ss')).valueOf());
      
      // React big calendar has a bug (IMO) and fails to display periods that 
      // end at midnight. The end is change to 23:59 to get around this for now
      let end = moment(cloned_item.dtstart.valueOf() + ((cloned_item.duration) * 1000) );
      if (end.format('HH:mm:ss') === '00:00:00') {
        // end.add(1, 'minute');
      }
      
      cloned_item.end = end.toDate();
      calendar_items_recurring.push(cloned_item);
    })
  })
  
  const isOverlapping = checkOverlapping(calendar_items_recurring);
  
  calendar_items_recurring.forEach((item) => {
    item.overlapping = false;
    
    isOverlapping.schedules.forEach((overlapping_id) => {
      if (overlapping_id === item.id) {
        item.overlapping = true;
      }
    })
  })
  
  moment.locale('gb', {
      week: {
          dow: 1
      },
  });

  const localizer = momentLocalizer(moment) // or globalizeLocalizer
  
  let formats = {
    timeGutterFormat: 'HH:mm'
  }
  
  function log_event_select(slotInfo) {
    console.log(slotInfo);
    console.log({dtstart: moment(slotInfo.start).format('YYYY-MM-DD HH:mm:ss'), duration: (slotInfo.end.getHours() - slotInfo.start.getHours())*3600, byweekday: [slotInfo.start.getDay()-1]});
  }
  
  function convertJsToRruleDays(js_day) {
    const rrule_days = [6, 0, 1, 2, 3, 4, 5];
    return rrule_days[js_day]
  }
  
  function setFocusBorders(props) {
    const style: ScheduleStyle = {background: props.style.background}
    let line_type = 'solid'
    
    if (!props.saved) {
      line_type = `dashed`;
    }
    
    if (props.focus) {
      if (props.saved) {
        style.border = `3px solid  ${props.style.border}`;
      } else {
        style.border = `3px dashed  ${props.style.border}`;
      }
    } else {
      if (props.saved) {
        style.border = `1px solid  ${props.style.border}`;
      } else {
        style.border = `2px dashed  ${props.style.border}`;
      }
    }
    
    if (props.overlapping) {
      style.border = `3px solid ${colour_lookup('red')}`;
    }
    
    return {style: style}
  }
  
   // Checks if the right firmware version is available
   const has_capability = selectedNodes.length > 0 && selectedNodes[0].features.use_power_schedules !== null;
  
  return (
      <StyledContainer>
        <Middle>
          {selectedNodes.length > 0 ? 
            <PowerSchedulesToggle>
              {has_capability && <ToggleLabel>{selectedNodes[0].features.use_power_schedules? 'Power Saving' : 'Disabled'}</ToggleLabel>}
              {has_capability && <Toggle selected={selectedNodes.length > 0? selectedNodes[0].features.use_power_schedules : false} onClick={() => { dispatch(toggleUsePowerSchedules(selectedNodes)) }}/>}
            </PowerSchedulesToggle>
          : null}
          {selectedNodes.length == 0 ? <SelectMessage/> : null}
          {selectedNodes.length > 0 && !has_capability? <FirmwareMessage/> : null}
          {selectedNodes.length > 0 && !selectedNodes[0].features.use_power_schedules && has_capability? <DisabledMessage/> : null}
          {selectedNodes.length > 0 && selectedNodes[0].features.use_power_schedules && has_capability? 
            <StyledBigCalendar
              localizer={localizer}
              events={calendar_items_recurring}
              startAccessor="dtstart"
              endAccessor="end"
              defaultView='week'
              showMultiDayTimes={true}
              step={60}
              timeslots={1}
              formats={formats}
              resizable={true}
              popup={true}
              components={{
                day: { header: MyCustomHeader },
                week: { header: MyCustomHeader },
                month: { header: MyCustomHeader },
                toolbar: MyCustomToolbar
              }}
              selectable={true}
              // onSelectSlot={log_event_select}
              onSelectSlot={(slotInfo) => dispatch(newSchedule({
                newSchedule: {
                  title: 'New Alarm',
                  dtstart: moment(slotInfo.start).format('YYYY-MM-DD HH:mm:ss'), 
                  duration: (slotInfo.end.getHours() - slotInfo.start.getHours())*3600, 
                  byweekday: [convertJsToRruleDays(slotInfo.start.getDay())],
                  category: 'alarms'
                },
                selectedNodes: selectedNodes
              }))}
              onSelectEvent={(event, e) => dispatch(focusSchedule({id: event.id}))}
              // onSelectEvent={log_event_select}
              eventPropGetter={setFocusBorders}
            />
          : null}
        </Middle>
        <Right>
          {focusedSchedule != null && selectedNodes.length > 0 && selectedNodes[0].features.use_power_schedules && has_capability?
          <EditPanel schedule={focusedSchedule} schedules={calendar_items} isOverlapping={isOverlapping}/>
          : null}
        </Right>
      </StyledContainer>
  );
}